import { Agencies } from "./agencies";



export class Mobile_Apps {

    id: number;

    name: string;

    playstore_url: string;

    appstore_url: string;

    agencyName:any;

    Agency: Agencies[];

    Mobile_cover_image_url: string;

    mobile_cover_image_url: any;

}